import axios from "axios";
import { loadAndTrack } from "redux-request-loading";
import * as actionTypes from "@teamprevent/common/questionnaires/questionnaireConfig/actionTypes";
import { Dispatch } from "redux";
import { questionnaireConfigLoaded } from "@teamprevent/common/questionnaires/questionnaireConfig/actionTypes";
import { ConfigurableQuestionnaireKey } from "@teamprevent/common/questionnaires/questionnaireConfig/models";
import { TermsAndConditionsOfUseConfig } from "@teamprevent/common/termsAndConditions/model";

import { QuestionnaireConfigApi } from "./QuestionnaireConfigApi";

export const buildLoadQuestionnaireConfig = (questionnaireConfigApi: QuestionnaireConfigApi, questionnaireType: ConfigurableQuestionnaireKey) =>
    () => {
        return async (dispatch: Dispatch) => {
            const result = await loadAndTrack(dispatch, actionTypes.LOAD_QUESTIONNAIRE_CONFIG, questionnaireConfigApi.get(questionnaireType));
            dispatch(questionnaireConfigLoaded({ questionnaireType, ...result }));
        };
    };

export const loadReferralConfig = buildLoadQuestionnaireConfig(new QuestionnaireConfigApi(axios), "referral");
export const loadPpqManagerConfig = buildLoadQuestionnaireConfig(new QuestionnaireConfigApi(axios), "ppqManagerSection");
export const loadPhysiotherapyMgrReferralConfig = buildLoadQuestionnaireConfig(new QuestionnaireConfigApi(axios), "physiotherapyMgrReferral");
export const loadInitialWorkAdjustmentQuestionnaireConfig =
    buildLoadQuestionnaireConfig(new QuestionnaireConfigApi(axios), "initialWorkAdjustmentQuestionnaire");
export const loadSraManagerConfig = buildLoadQuestionnaireConfig(new QuestionnaireConfigApi(axios), "sraManagerSection");
export const loadTermsAndConditionsOfUseConfig = buildLoadQuestionnaireConfig(new QuestionnaireConfigApi(axios), TermsAndConditionsOfUseConfig);
export const loadGenericCaseConfig = buildLoadQuestionnaireConfig(new QuestionnaireConfigApi(axios), "genericCase");
